var sdk = null;

var monitorTaskCode = null;
var taskCode = null;
var alarmTaskObject = null;
var alarmAcceptTaskObject = null;

//设备SipNum【音频需要设备SipNum】、设备Id【视频需要设备id】、该条数据的id【压视频或者音频】、标记【判断如果是第二次接警走平台呼设备流程】、接警之后的关闭
let sipNum_top = '', equipmentId = '', divId = '', sign = 0, audioSign = false, closeSign = 0;

async function openSDK(divid, type, obj, userName, sdkObj) {

  showTip('开启中，请稍等...', 'success', 200, 2000, 200);

  sdk = sdkObj;
  divId = divid;
  if (obj) {
    alarmTaskObject = JSON.parse(obj);
  }
  sipNum_top = JSON.parse(obj).DeviceSipNum;
  equipmentId = JSON.parse(obj).DeviceId;

  //主动报警
  if (type == 'zd') {
    //应急呼叫接警
    sign++;
    if (sign > 1) {
      openAlarm();
    } else {
      openAlarm();
    }
  } else if (type == 'list') {
    openVideo('list');
  }

  // sdk初始化会有一个过程，包括与初始化自己本身，与服务器交互等过程，需要等待
  // sdk.init().then(() => {
  //   // 初始化成功（这里成功之后，也会通过sdk.addEventListener(SOS.EVENT.SUCCESS)的消息通知到）
  //   showTip('SDK成功启动!', 'success', 100, 1000, 100);
  //   setTimeout(function(){
  //     //主动报警
  //     if(type == 'zd'){
  //       sign++;
  //       if(sign>1){
  // 			openAlarm();
  //       }else{
  //         openAlarm();
  //       }
  //     }else if(type == 'list'){
  //       openVideo('list');
  //     }
  //   },100)
  // })
  // .catch(error => {
  // })
}

function closeSDK() {
  return;
  if (sdk) {
    sdk.destroy().then(() => {
      sdk = null;
    }).catch(() => {
      sdk = null;
    });
  } else {
  }
}

// list
async function openVideo(type) {
  if (sdk) {
    let stopCallback = () => {
      // 开始监控之后，服务器结束了监控
      showTip('监控结束', 'error', 200, 2000, 200);
    }

    try {
      let task = await sdk.videoMonitorStart({
        // Device: {
        //     Id: parseInt(equipmentId),
        //     Name: "lzz"
        // },
        DeviceId: parseInt(equipmentId),
        VideoDomId: 'id' + divId,
        OnStop: stopCallback,
      });

      monitorTaskCode = task.TaskCode;
      // showTip('视频开启成功!', 'success', 200, 2000, 200);
      showTip('视频已接通请通话!', 'success', 200, 2000, 200);
      // if (type === 'zd') { // 回呼也打开截屏
        setTimeout(() => {
          let video = document.getElementById('id' + divId)
          let canvas = document.getElementById('canvas' + divId);
          let ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, 580, 326);
          let imgUrl = canvas.toDataURL('image/png');

          canvas.style.display = 'none';

          let submit = {};
          submit.base64Img = imgUrl;
          submit.id = divId.split('id')[1];

          $.ajax({
            type: 'POST',
            url: '/apis/webapi/probeEquipment/addClueImg',
            data: submit,
            async: false,
            // beforeSend:function(XMLHttpRequest){
            // 	XMLHttpRequest.setRequestHeader("ref", this.store.state.ref);
            // },
            error: function (req) {
              console.log(req)
            },
            success: function (req) {
              console.log('设备截图成功！')
            }
          })

        }, 3 * 1000)
      // }

    } catch (error) {
      showTip('视频开启失败!', 'error', 200, 2000, 200);
    }
    if (type === 'list') {
      setTimeout(function () {
        openAudio();
      }, 100)
    }
  } else {
    showTip('获取监控视频失败，请先启动SDK', 'warning', 200, 2000, 200);
  }


}

async function closeVideo() {
  if (sdk) {
    try {
      await sdk.videoMonitorStop({
        TaskCode: monitorTaskCode
      });
    } catch (error) {

    }

    if (audioSign) {
      closeAudio();
    }

    setTimeout(function () {
      closeSDK();
    }, 1500)

  } else {
    showTip('停止监控视频失败，请先启动SDK!', 'warning', 200, 2000, 200);
  }
}

function openAudio() {
  let disconnectedCallback = (SipNum) => {
    // 开始对讲之后，有设备或自己退出对讲
    showTip(SipNum + '已退出对讲', 'warning', 200, 2000, 200);
  }
  let stopCallback = () => {
    // 开始对讲之后，服务器结束了对讲
    showTip('服务器结束对讲!', 'error', 200, 2000, 200);
  }

  if (sdk) {
    sdk.audioSpeakStart({
      // 必填参数
      SipNum: sipNum_top,
      AudioDomId: "audio"+divId,
      // 非必填参数
      Force: false,
      OnDisconnected: disconnectedCallback,
      OnStop: stopCallback,
    }).then((ret) => {
      taskCode = ret.TaskCode;
      //domTips.innerHTML="对讲成功, taskCode（对讲任务码，结束时候要用）:" + taskCode + " expire（对讲时间，单位秒，超过这个时间服务器会自动结束掉，sdk会通过OnStop回调通知）:" + ret.ExpireIn
      // showTip('音频开启成功!', 'success', 200, 2000, 200);
      showTip('视频已接通请通话!', 'success', 200, 2000, 200);
      audioSign = true;

    }).catch((e) => {
      showTip('音频开启失败！', 'error', 200, 2000, 200);
      switch (e.code) {
        case 2005:
          showTip('对讲失败，设备不存在，检查一下SipNum是否错误', 'error', 200, 2000, 200);
          break;
        case 3551:
          showTip('对讲失败，本端坐席忙（本端已在另外的一个对讲任务中）', 'error', 200, 2000, 200);
          break;
        case 3552:
          showTip('对讲失败，设备忙（设备已在另外的一个对讲任务中），被其他人坐席端对讲了', 'error', 200, 2000, 200);
          break;
        default:
          break;
      }
    })
  } else {
    showTip('音频开启失败，请先启动SDK', 'error', 200, 2000, 200);
  }
}

function closeAudio() {
  if (sdk) {
    sdk.audioSpeakStop({
      TaskCode: taskCode
    }).then(() => {
      //对讲停止
      audioSign = false;
    }).catch((error) => {
      //对讲停止  关闭语音失败
    })
  } else {
    showTip('对讲停止失败，请先启动SDK！', 'error', 200, 2000, 200);
  }
}

async function openAlarm() {
  if (sdk) {
    try {
      let disconnectedCallback = (SipNum) => {
        // 开始对讲之后，有设备或自己退出对讲
        showTip('已退出接警!', 'success', 200, 2000, 200);
      }
      let stopCallback = () => {
        // 开始对讲之后，服务器结束了对讲
        showTip('服务器结束接警!', 'success', 200, 2000, 200);
      }
      alarmAcceptTaskObject = alarmTaskObject
      let rsp = await sdk.deviceAlarmAccept(alarmTaskObject, {
        AudioDomId: "audio" + divId,
        // 非必填参数
        OnDisconnected: disconnectedCallback,
        OnStop: stopCallback,
      });
      // domTips.innerHTML="接警成功, taskCode（对讲任务码，结束时候要用）:" + rsp.TaskCode + " expire（接警时间，单位秒，超过这个时间服务器会自动结束掉，sdk会通过OnStop回调通知）:" + rsp.ExpireIn
      showTip('接警成功,音频开启成功!', 'success', 200, 2000, 200);
      setTimeout(function () {
        openVideo('zd');
      }, 500)
    } catch (error) {
      //domTips.innerHTML="接警失败" + formatJson(error)
      // showTip('接警失败!', 'error', 200, 2000, 200);
    }
  } else {
    showTip('接警失败，请先启动SDK!', 'warning', 200, 2000, 200);
  }
}

async function closeAlarm(type) {
  if (sdk) {
    try {
      let rsp = await sdk.deviceAlarmDone(alarmAcceptTaskObject);
      closeVideo()
    } catch (error) {

    }

  } else {
    showTip('结束接警失败，请先启动SDK', 'error', 200, 2000, 200);
  }
}

function showTip(tip, type, time1, time2, time3) {
  var $tip = $('#dialogTip');
  $tip.stop(true).prop('class', 'alert alert-' + type).text(tip).css('margin-left', - $tip.outerWidth() / 2).fadeIn(time1).delay(time2).fadeOut(time3);
}

export {
  openSDK,
  openAudio,
  closeAudio,
  closeVideo,
  closeAlarm
}



// WEBPACK FOOTER //
// ./src/js/shieldKing.js